module.exports = __webpack_public_path__ + "img/HCPI.0acbbfd4.svg";